import {FC} from "react";
import {ITypeRadar} from "../../../types";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import ImgMockDesc from "../../../assets/images/mock-description-initiative.jpg";
import {Iprojects} from "../../../pages/Esg/EsgDashboard.type";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleCard} from "../styles";
import {apiKeyDataEsg, urlApiDataEsg} from "../../../helper/api";
import useFetchDataEsgProjectById from "../../../hooks/useFetchDataEsgProjectById";
import {BlockGraphLevelTrend} from "../SidebarCardUI/BlockGraphLevelTrend";

import IconPotentionGrowActive from "../../../assets/icons/sorterByCard/active/globe.svg";
import IconDollarFlowerActive from "../../../assets/icons/sorterByCard/active/flower.svg";
import IconDollarZigzagActive from "../../../assets/icons/sorterByCard/active/zig-zag.svg";
import IconDollarQuadro from "../../../assets/icons/sorterByCard/active/icon-dollar_blue_card.svg";

interface IProps {
  typeRadar: ITypeRadar;
  colorTitle?: string;
  projectId: string;
}

export const SideBarContentEsg: FC<IProps> = ({
  typeRadar,
  colorTitle,
  projectId,
}) => {
  console.log("projectId", projectId);
  const apiUrl = `${urlApiDataEsg}/api/projects`;
  if (!apiKeyDataEsg) {
    throw new Error("API key не тот");
  }

  const {projectData} = useFetchDataEsgProjectById(
    apiUrl,
    apiKeyDataEsg,
    projectId
  );

  const data = projectData?.data;

  return (
    <div>
      <TitleCard color={colorTitle}>{data?.name}</TitleCard>
      <br />
      {/* <BlockToggleDescriptionTehnology
        data={<BlockDescription text={data?.description} image={ImgMockDesc} />}
        isOpen
        typeRadar={typeRadar}
      /> */}
      <BlockDescription
        text={data?.description}
        // text="Описание инициативы"
        image={ImgMockDesc}
        type="description"
      />

      <div>
        {(data?.marketVolume ||
          (data?.cagrLowerBound && data?.cagrUpperBound) ||
          data?.rankTier ||
          (data?.irrLowerBound && data?.irrUpperBound) ||
          data?.averageProjectVolume) && (
          <>
            <br />
            <TitleBlockTrend title="Название рынка" tooltip="Название рынка" />
          </>
        )}

        {data?.marketVolume && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconPotentionGrowActive}
              title={"Размер рынка"}
              description={
                data.marketVolume > 1000
                  ? `${parseFloat(
                      (data.marketVolume / 1000).toFixed(2)
                    ).toString()} трлн $`
                  : `${data.marketVolume} млрд $`
              }
            />
          </>
        )}
        {data?.cagrLowerBound && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarFlowerActive}
              title={"CAGR"}
              description={`${data?.cagrLowerBound} — ${data?.cagrUpperBound} %`}
            />
          </>
        )}

        {data?.rankTier && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarZigzagActive}
              title={"RANK"}
              description={`${data.rankTier}`}
            />
          </>
        )}

        {data?.irrLowerBound && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarQuadro}
              title={"IRR"}
              description={`${data?.irrLowerBound} — ${data?.irrUpperBound}`}
            />
          </>
        )}

        {data?.averageProjectVolume && (
          <>
            <br />
            <BlockGraphLevelTrend
              icon={IconDollarQuadro}
              title={"Средний размер проекта"}
              description={`${data.averageProjectVolume} млн $`}
            />
          </>
        )}
      </div>
      <br />
      <BlockToggleDescriptionTehnology
        data={data?.demandStructure}
        title={<TitleBlockTrend title="Структура спроса" />}
        typeRadar={typeRadar}
      />
      <br />
      <BlockToggleDescriptionTehnology
        data={data?.technologicalTrends}
        title={<TitleBlockTrend title="Технологические тренды" />}
        typeRadar={typeRadar}
      />
      <br />
      <BlockToggleDescriptionTehnology
        data={data?.swotAnalysis}
        title={<TitleBlockTrend title="SWOT анализ" />}
        typeRadar={typeRadar}
      />
      <br />
    </div>
  );
};
